import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TenantInactiveModalComponent } from './shared/components/tenant-inactive-modal/tenant-inactive-modal.component';
import { UserInactiveModalComponent } from './shared/components/user-inactive-modal/user-inactive-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    TenantInactiveModalComponent,
    UserInactiveModalComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(readonly authService: AuthService) {}
}
